import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getVendors } from 'api/Vendors';

export const useVendors = ({ params, options }) => {
  const navigate = useNavigate();
  const { search, page, limit, filters } = params;
  return useQuery(['vendors', search, page, limit, filters], () => getVendors(navigate, params), {
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    ...options
  });
};
